import { ROLES } from '@/constants/roles';
import { DRAWER_TYPES } from '@/constants/drawer';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue'),
    meta: {
      title: 'Вход',
      guest: true,
    },
  },
  {
    path: '/certificate-create',
    component: () => import('./views/GetCertificate/index.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('./views/Register/index.vue'),
    meta: {
      title: 'Регистрация',
      guest: true,
      subdrawer: DRAWER_TYPES.portal,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('./views/ForgotPassword/index.vue'),
    meta: {
      title: 'Восстановление пароля',
      guest: true,
    },
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('./views/VerifyEmail.vue'),
    meta: {
      title: 'Подтверждение почты',
      // guest: true,
    },
  },
  {
    path: '/auth-code',
    name: 'auth-code',
    component: () => import('./views/AuthCode.vue'),
    meta: {
      title: 'Вход по коду',
      guest: true,
    },
  },
  {
    path: '/create-organization',
    name: 'create-organization',
    // component: () => import('./views/Noreg.vue'),
    component: () => import('./views/CreateOrganization.vue'),
    meta: {
      title: 'Создании организации',
      guest: true,
    },
  },
  {
    path: '/auth-token',
    name: 'auth-token',
    component: () => import('./views/AuthToken.vue'),
    meta: {
      title: 'Вход по токену',
      guest: true,
    },
  },
  {
    path: '/telegram-auth/redirect',
    name: 'auth-redirect-telegram',
    component: () => import('./views/RedirectToken.vue'),
    meta: {
      title: 'Регистрация через Telegram',
      layout: 'redesign',
      noHeader: true,
      guest: true,
      hideDrawer: true,
    },
  },
  {
    path: '/vk-auth/redirect',
    name: 'auth-redirect-vk',
    component: () => import('./views/RedirectToken.vue'),
    meta: {
      title: 'Регистрация через VK',
      layout: 'redesign',
      noHeader: true,
      guest: true,
    },
  },
  {
    path: '/activate-profile',
    name: 'activate-profile',
    component: () => import('./views/activate-profile.vue'),
    meta: {
      title: 'Активация профиля',
      layout: 'redesign',
      noHeader: true,
      accessList: [ROLES.guest, ROLES.expert],
    },
  },
];

export default routes;
